import './DeleteDocumentExecutor.scss';
import React from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router';
import MessageDialog, { IMessageDialogProps } from '@srm/ui/message-dialog';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { RouteNames } from '@/router/router.types';
import { IDeleteDocumentExecutorProps } from './IDeleteDocumentExecutorProps';

export const DeleteDocumentExecutorModal: React.FC<IDeleteDocumentExecutorProps> = (
    props: IDeleteDocumentExecutorProps,
) => {
    const navigate = useNavigate();
    const location = useLocation();

    const { errorText, isBusy, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: () => new DocumentExecutionService(props.docId).deleteDocument(props.actionKey),
        onSuccess: () => {
            // С карточки удалённого документа уходим на дашборд, из списка — просто закрываемся
            if (matchPath(RouteNames.DOCUMENT, location.pathname)) {
                navigate(RouteNames.DASHBOARD);
            } else {
                props.completeHandler && props.completeHandler(true);
            }
        },
    });

    const messageBoxProp: IMessageDialogProps = {
        header: props.title,
        message: props.message,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        size: props.modalSize,
        onConfirm: okClick,
        onCancel: cancelClick,
    };

    return <MessageDialog {...messageBoxProp} errorText={errorText} loading={isBusy} />;
};
